import { Tag } from "Components";
import { PropertyData } from "../CampaignReport.type";
import { GET_COLOR_BY_SCORE } from "../CampaignReport.constant";

const PropertyListItem = ({ propertyData }: { propertyData: PropertyData }) => {
    const { color: resultColor, bg: resultBg } = GET_COLOR_BY_SCORE(propertyData?.passRate || 0);

    return <div className='list-item property-item'>
        <div className='row'>
            <span className='title'>{propertyData?.propertyName || ''}</span>
            <Tag className='status-tag' style={{ color: resultColor, background: resultBg }}>
                {`${propertyData?.passRate || ''}%`}
            </Tag>
        </div>
        <div className='row'>
            <span className='description'><strong>Open: </strong>{propertyData?.openRate || ''}</span>
            <span className='description'><strong>Click: </strong>{propertyData?.clickRate || ''}</span>
        </div>
        <div className='row'>
            <span className='description'><strong>Sent: </strong>{propertyData?.emailsSent || ''}</span>
            <span className='description'><strong>Submit: </strong>{propertyData?.submissionRate || ''}</span>
        </div>
        <div className='row'>
            <span className='description'><strong>Clicked: </strong>{propertyData?.clickedLink || ''}</span>
            <span className='description'><strong>Submitted: </strong>{propertyData?.submissionRate || ''}</span>
        </div>
        <div className='row'>
            <span className='description'><strong>Opened: </strong>{propertyData?.openedEmail || ''}</span>
            <span className='description'><strong>Total Users: </strong>{propertyData?.totalUsers || ''}</span>
        </div>
    </div>
}

export default PropertyListItem;